<template>
    <div class="not-found container d-flex flex-column align-items-center justify-content-center">
        <h1 class="font-primary">404</h1>
        <p>{{$t('PAGE_NOT_FOUND')}}</p>
    </div>
</template>